import { LocalizationProvider, DatePicker as DatePicker$1 } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React__default from 'react';

/* const handleCalendarClick = (event: React.MouseEvent<HTMLDivElement>) => {
  event.stopPropagation();
}; */
const DatePicker = ({ size = 'normal', dateFormat = 'DD/MM/YYYY', error = false, ...props }) => {
    const styles = {
        '.MuiPickersDay-root': {
            backgroundColor: 'white !important',
            borderColor: 'white',
            '&:hover': { backgroundColor: '#E9DDF0 !important' },
        },
        '.Mui-selected': {
            backgroundColor: '#8a00e5 !important',
            color: 'white',
        },
        '.MuiPickersDay-today': {},
        '.MuiPickersDay-today.selected': {},
        '.MuiPickersDay-today:hover': {},
        '.MuiPickersDay-daySelected': {},
    };
    styles['.MuiPickersDay-today'] = {
        backgroundColor: 'white !important',
        borderColor: 'white !important',
    };
    styles['.MuiPickersDay-today.selected'] = {
        backgroundColor: 'white !important',
        borderColor: 'white !important',
    };
    styles['.MuiPickersDay-today:hover'] = {
        backgroundColor: '#E9DDF0 !important',
    };
    return (React__default.createElement(React__default.Fragment, null,
        props.label ? React__default.createElement("label", { htmlFor: props.id }, props.label) : null,
        React__default.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
            React__default.createElement(DatePicker$1, { disableHighlightToday: true, format: dateFormat, disabled: props.disabled, onChange: (newValue) => {
                    if (props.onChange) {
                        props.onChange(newValue ? newValue.unix() : null);
                    }
                }, value: props.defaultValue ? dayjs.unix(props.defaultValue) : null, sx: {
                    width: '100%',
                    '.MuiPickersDay-today': {
                        backgroundColor: 'white !important',
                        borderColor: 'white !important',
                    },
                    '& .MuiOutlinedInput-root': {
                        '&::placeholder': {},
                        '& > fieldset': {
                            borderColor: !error ? '#DEE2E6' : 'red',
                            borderWidth: 1,
                        },
                        '&:hover > fieldset': {
                            borderColor: !error ? '#DEE2E6' : 'red',
                            borderWidth: 1,
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#8a00e5',
                            borderWidth: 1,
                        },
                        height: size === 'normal' ? '40px' : '32px',
                        fontSize: size === 'normal' ? 14 : 13,
                        borderRadius: '6px',
                    },
                }, slotProps: {
                    layout: {
                        sx: styles,
                    },
                    field: { clearable: false },
                    popper: {
                        disablePortal: true,
                    },
                } }))));
};

export { DatePicker as default };
//# sourceMappingURL=DatePicker.js.map
